import CulvertEditor from "./CulvertEditor";
import {useEffect, useState} from "react";

export default function CulvertWindow({riverStation}) {
    const [culvert, setCulvert] = useState('')

    useEffect(() => {
        if(!culvert && riverStation?.base_culverts?.length > 0)
            setCulvert(riverStation?.base_culverts[0]?.culvert_name)
    }, [riverStation]);

    return (
        <>
            <div style={{display: 'flex', alignItems: 'center', gap: 16}}>
                {
                    riverStation?.base_culverts?.length > 0 ? (
                        <CulvertEditor
                            windowName={'culvert-base'}
                            selectedCulvert={culvert}
                            onChangeCulvert={(culvert) => setCulvert(culvert)}
                            data={riverStation?.base_culverts}
                            title={riverStation?.base_title}
                        />
                    ) : (<></>)
                }
                {
                    riverStation?.cmp_culverts?.length > 0 ? (
                        <CulvertEditor
                            windowName={'culvert-cmp'}
                            targetWindow={'culvert-base'}
                            selectedCulvert={culvert}
                            onChangeCulvert={(culvert) => setCulvert(culvert)}
                            data={riverStation?.cmp_culverts}
                            title={riverStation?.cmp_title}
                        />
                    ) : (<></>)
                }
            </div>
        </>
    )
}